import Head from "next/head"

const RegisterSeo = () => {
	return (
		<Head>
			<title>LU | Register</title>
			<link
				rel="icon"
				href="/favicon.ico"
			/>
		</Head>
	)
}

export default RegisterSeo
